import React, { useState } from 'react'
import { withTranslation } from 'react-i18next'
import { arpHook } from 'athlete-api-client'
import { useParams } from 'react-router-dom'
import moment from 'moment-timezone'
import { textStyles } from '../../shared/styles'
import { PageTemplate } from '../home/PageTemplate'
import { styles } from './styles'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
import { AthleteRacePageCard } from './AthleteRacePageCard'
import { DotDotDot } from '../../components/shared/icons'
import { Loading } from '../../components/shared/Loading'
import { RaceSummary } from '../../components/ARP/RaceSummary'
import { Countdown } from '../../components/ARP/Countdown'
import { Goals } from '../../components/ARP/Goals'
import { getToken } from '../../utils/isLoggedIn'
import { ProfileTag } from '../../components/ARP/ProfileTag'
import { AthletePhoto } from '../../components/athlete/AthletePhoto'

const AthleteRacePageComponent = (props) => {
  const { entryId } = useParams('/:entryId')
  const [viewAllSimilar, setViewAll] = useState(false)
  const [showRaceSummary, setShowRaceSummary] = useState(false)

  let arp = arpHook(entryId, {
    fetchToken: getToken
  })
  if (!arp) {
    return <Loading centered={true}/>
  }

  const {
    isMobile,
    t
  } = props

  const renderLeftContent = () => {
    return (
      <div>
        <div style={styles.athleteContainer(isMobile)}>
          <AthleteRacePageCard
            athleteCardModel={arp.athleteCardModel}
            isMobile={isMobile}
            isPublicProfile={true}
            t={props.t}/>
        </div>
        <div style={styles.friendsContainer}>
          <div style={styles.athleteHeader}>{t('Similar Athletes in this Event').toUpperCase()}</div>
          {arp.similarAthletesCardModel.athletes.slice(0, viewAllSimilar ? 8 : 3).map((athlete, index) => {
            return isMobile ? (
              athlete.showAthletePhoto && <div key={index} style={{marginTop: '14px', display: 'inline-block'}}>
              <AthletePhoto
                isMember={!!athlete.racerId}
                photo={athlete.photos}
                name={athlete.displayName}
                width={32}
              /></div>) : <ProfileTag key={index} {...athlete} isLoggedIn={arp.isLoggedIn} courseName={arp.coursesCardModel[0].name} t={props.t} />
          })}
          <div style={styles.similarAthletesContainer(isMobile)}>
            <button
              disabled={false}
              onClick={() => setViewAll(!viewAllSimilar)}
              style={{...styles.clearButton(isMobile), display: arp.similarAthletesCardModel.athletes.length <= 3 ? 'none' : ''}}
            >{t(viewAllSimilar ? 'View Less' : 'View All')}</button>
          </div>
        </div>
      </div>
    )
  }

  const renderRaceContent = () => {
    const labelStyle = {...textStyles.sectionHead }
    // TODO: when we implement a course/reg choice toggle change the index for arp.courses
    return (
      <div style={styles.raceContentContainer(isMobile)}>
        <div style={styles.raceSelectionContainer(isMobile)}>
          {arp.coursesCardModel.map((course, index) => (
            <div key={'course_' + course.courseId} style={index === 0 ? styles.raceSelected : styles.raceDeselected}>{course.name}</div>
          ))}
        </div>
        <div style={styles.betaBar}>
          <span style={styles.betaBadge}>BETA</span>
        </div>
        { isMobile && <div>
          <hr style={{margin: '18px 0px 8px'}} />
          <div className={isMobile ? 'col-12' : 'col-5'}
            onClick={() => setShowRaceSummary(!showRaceSummary)}
            style={{cursor: 'pointer', overflow: 'hidden', height: showRaceSummary ? 175 : 25}}>
            <div style={{marginTop: '-2px', fontFamily: 'ProximaNovaBold', fontSize: '23px', float: 'right'}}>{showRaceSummary ? '-' : '+'}</div>
            <RaceSummary raceCardModel={arp.raceCardModel}/>
          </div>
          <hr style={{margin: '6px 0px 28px'}}/>
        </div>}
        <div className='row'>
          <div className={isMobile ? 'col-12' : 'col-7'} style={styles.countdownContainer}>
              <Countdown startDateTime={arp.raceCardModel.startDateTime} irp={arp.raceCardModel.irp} isMobile={isMobile} t={props.t} />
              <Goals raceCardModel={arp.raceCardModel} claimed={arp.claimed} isMobile={isMobile} t={props.t} />
            {!arp.claimed && <div style={styles.zeroStateBlurb}>
              {t('Claim this race page to set goals!')}
            </div>}
            <div className={'col-12'} style={styles.claimButtonContainer}>
              <button
                disabled={false}
                onClick={() => {}}
                style={styles.claimButton(arp.claimed, isMobile)}
              >{t(arp.claimed ? 'claimed' : 'claim your race').toUpperCase()}</button>
            </div>
          </div>
          { !isMobile && <div className={isMobile ? 'col-12' : 'col-5'}>
            <RaceSummary raceCardModel={arp.raceCardModel} t={props.t}/>
          </div>}
        </div>
      </div>
    )
  }

  const renderTopContent = () => {
    const dateTime = moment(parseInt(arp.eventCardModel.startDateTime.timeInMilliseconds)).tz(arp.eventCardModel.startDateTime.timeZone)
    const formattedDate = dateTime.format('LL')
    return (
      <div className={'container'} style={styles.mainInfoContainer}>
        
        <div style={styles.outerInfoContainer(isMobile)}>
          <ChevronLeftIcon style={styles.chevronLeft(isMobile)} />
          <div style={styles.more}>
            <DotDotDot/>
          </div>
          <div style={styles.innerInfoContainer}>
            <div style={styles.eventName(isMobile)}>
              {arp.eventCardModel.name}
            </div>
            <div className={'row'}>
              <div style={styles.eventDate}>
                {`${formattedDate}`}
              </div>
              <div style={styles.eventLocation}>
                {`${arp.eventCardModel.location.city}, ${arp.eventCardModel.location.region}, ${arp.eventCardModel.location.country}`}
              </div>
            </div>
          </div>
        </div>
        <div style={styles.buttonContainer(isMobile)}>
            <div></div>
            <button
              onClick={() => {}}
              style={styles.registerButton(isMobile)}
            >
              {t('Register')}
            </button>
          </div>
      </div>
    )
  }

  return (
    <PageTemplate
      {...props}
      headerIsFixed={true}
      paddingTop={0}
      unifiedSearchMode={true}
    >
      <div>
        <div style={{overflow: 'hidden'}}>
          <div style={styles.topContainer}>
            <img src='http://placekitten.com/1920/1080'/>
          </div>
        </div>
        <div className='container'>
          {renderTopContent()}
        </div>
      </div>
      <div className='container' style={styles.bodyContainer(isMobile)}>
        <div className='row'>
          <div className={isMobile ? 'col-12' : 'col-4'}>
            {renderLeftContent()}
          </div>
          <div className={isMobile ? 'col-12' : 'col-8'}>
            {renderRaceContent()}
          </div>
        </div>
      </div> 
    </PageTemplate>
    )
}
export const AthleteRacePage = withTranslation()(AthleteRacePageComponent)



/** WEBPACK FOOTER **
 ** ./views/athleteRacePage/AthleteRacePage.js
 **/